var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('div', {
    staticClass: "tit-wrap mb-3"
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("최근 캐시 사용 내역")]), _c('v-btn', {
    staticClass: "my-n2",
    attrs: {
      "dense": "",
      "small": "",
      "text": "",
      "color": "grey",
      "to": "/mypage/cashes/inquiry"
    }
  }, [_vm._v("더보기 "), _c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1), _c('div', [_c('v-data-table', {
    attrs: {
      "items": _vm.cashes,
      "headers": _vm.cashesHeaders,
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": "",
      "no-data-text": "구매 내역이 없습니다."
    },
    scopedSlots: _vm._u([{
      key: "item.createdAt",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))]);
      }
    }, {
      key: "item.amount",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return _c('span', {}, [_vm._v(_vm._s(parseInt(+item.amount || 0).format()) + "원")]);
      }
    }, {
      key: "item.result",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return _c('span', {}, [_vm._v(_vm._s(parseInt(+item.result || 0).format()) + "원")]);
      }
    }])
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }